export default {
  common: {
    projectList: "项目列表",
    pleaseInputProjectName: "此处输入项目名称搜索",
    pipeline: "流程管理",
    onhold: "进行中",
    win: "已赢得",
    loss: "未赢得",
    city: "城市",
    amount: "金额",
    winProbability: "赢得概率",
    registeredOn: "注册于",
    updatedOn: "更新于",
    thereAreNoMoreProjectsLeft: "没有更多项目了",

    drafting: "初始状态",
    ready: "就绪",
    shared: "已分享",
    negotiating: "正在进行",
    secured: "已取得",
    lost: "已丢失",
    onhold: "暂停",

    INITIAL: "初始状态",
    ECM_REPORT_PREPARED: "ECM报告等待客户共享",
    ECM_TO_CUSTOMER: "ECM报告发送给客户",
    CUSTOMER_KIV_PROPOSAL: " 客户保持关注建议",
    CUSTOMER_FUNDED: "客户确认项目已获资助",
    CUSTOMER_PROPOSAL: "客户就提案进行谈判",
    EA_TO_CUSTOMER: "EA报告发送给客户",
    CUSTOMER_ORDERS: "客户下单",
    LOST_TO_COMPETITION: "输给竞争对手",
    STATUS_PROJECT: "另一个项目中报告的状态",
    IN_ACTIVE: "项目暂停",
    getProjectInfoFailed: "项目数据获取失败",
    getCitylistFailed: "获取城市列表失败",
    cantGetProjectDetails: "获取项目详情失败",
    noProjectId: "缺少项目标识",
    noProjectState: "缺少项目状态",
    enterProjectName: "输入项目名称",
    noActualEcmQuoted: "缺少实际ECM报价"
  },
  projectDlg: {
    newProject: "新建项目",
    projectName: "项目名称",
    projectState: "项目状态",
    customer: "客户",
    address: "项目地址",
    customerEmail: "客户邮箱",
    auditDate: "审计日期",
    jobsiteCity: "工地所在城市",
    estimatedEcmQuoted: "评估ECM报价",
    exceptedOrder: "预估订单日期",
    winProbability: "赢得概率 %",
    saveRetrun: "保存并返回",
    saveAudit: "保存并审计",
    statusRemarks: "状态描述",

    actualEcmQuoted: "实际ECM报价",
    actualOrder: "实际订单日期"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/zh.js